import { isFunction, isObject } from '@bd/vue3-utils'
import { message } from 'ant-design-vue'
import { ref, type ExtractPropTypes, watch, type PropType } from 'vue'

// 请求props定义
export const apiProps = {
  /**
   * 请求接口函数
   */
  api: {
    type: Function as PropType<(...args: any) => Promise<any[]>>
  },
  /**
   * 接口函数参数
   */
  params: {
    type: [Object, String, Array, Number, Boolean],
    default: undefined
  },
  /**
   * 接口请求成功后的回调函数
   */
  afterLoad: {
    type: Function as PropType<(res: any) => any[]>
  },
  /**
   * 是否立即请求接口
   * @default true
   */
  immediate: {
    type: Boolean,
    default: true
  },
  /**
   * label字段
   * @default label
   */
  labelField: {
    type: String,
    default: 'label'
  },
  /**
   * value字段
   * @default value
   */
  valueField: {
    type: String,
    default: 'value'
  }
}
export interface DefaultOptionItem {
  label: any
  value: any
  disabled?: boolean
  [name: string]: any
}
/**
 * 格式化选项
 */
const formatOptions = (data: any[], labelField: string, valueField: string) => {
  return data.map(item => {
    if (isObject(item)) {
      return {
        ...item,
        label: item[labelField],
        value: item[valueField]
      }
    }
    return {
      label: item,
      value: item
    }
  })
}
export type ApiProps = ExtractPropTypes<typeof apiProps>
export const useApi = <T extends ApiProps>(props: T, attrs, emits) => {
  const options = ref<DefaultOptionItem[]>([])
  const loading = ref(false)
  const isFirstLoad = ref(true)
  const setFirestLoad = () => {
    if (isFirstLoad.value) isFirstLoad.value = false
  }
  const emitChange = () => emits('optionsChange', options.value)
  const getOptions = async () => {
    options.value = []
    if (attrs?.options) {
      options.value = formatOptions(attrs.options, props.labelField, props.valueField)
      emitChange()
      setFirestLoad()
      return
    }
    const api = props.api
    if (!api || !isFunction(api)) return
    loading.value = true
    try {
      let res = await api(props?.params)
      if (isFunction(props.afterLoad)) {
        res = props.afterLoad(res)
      }
      options.value = formatOptions(res, props.labelField, props.valueField)
      emitChange()
      setFirestLoad()
    } catch (err) {
      console.log(err)
      message.error('获取失败')
    }
    loading.value = false
  }
  const refresh = () => {
    emits('refresh')
    getOptions()
  }

  watch(
    () => props.params,
    () => {
      // 首次加载不执行
      !isFirstLoad.value && refresh()
    },
    { deep: true }
  )
  return {
    isFirstLoad,
    getOptions,
    options,
    loading,
    refresh
  }
}
